(function() {
    'use strict';

    angular
        .module('setupApp')
        .controller('PicAccountingDialogController', PicAccountingDialogController);

    PicAccountingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PicAccounting', 'CommonService'];

    function PicAccountingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PicAccounting, CommonService) {
        var vm = this;

        vm.picAccounting = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        CommonService.query({masterurl:'get-all-office'}, function(result){
			vm.lstOffice = result;
			if(vm.lstOffice.length > 1){
				vm.checkOfficeCode = true;
			}
			for( var i = 0; i < vm.lstOffice.length; i++){
        		if(vm.lstOffice[i].officeBankCode == vm.picAccounting.bankCode && vm.lstOffice[i].officeCode == vm.picAccounting.officeCode){
        			vm.officeBranchCode = vm.lstOffice[i].officeBranchCode;
        			break;
        		}
        	}
		});
        vm.officeDto= function(item){
    		if(vm.picAccounting.bankCode == null ||vm.picAccounting.bankCode == undefined || vm.picAccounting.bankCode ==''){
    			vm.enableOffice = true;
    		}else{
    			vm.enableOffice = false;
    			vm.officeBranchCode = item.officeBranchCode;
    			vm.picAccounting.officeCode = item.officeCode;
    		}
    		
    	}
        vm.save = save;
        vm.checkcreat = false;
        if (vm.picAccounting.picAccountingId != null || vm.picAccounting.picAccountingId != undefined) {
        	 vm.checkcreat = true;
        }
        if(vm.picAccounting.status == '1'){
        	vm.picAccounting.statusLimit = true;
        }else{
        	vm.picAccounting.statuslimit = false;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if(vm.picAccounting.statusLimit == true){
        		vm.picAccounting.status = '1';
        	}else{
        		vm.picAccounting.status = '0';
        	}
            if (vm.picAccounting.picAccountingId !== null) {
            	PicAccounting.update(vm.picAccounting, onSaveSuccess, onSaveError);
            } else {
            	PicAccounting.save(vm.picAccounting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('aApp:picAccountingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
